<template>
    <div>
        <TitleBar>
            <template v-slot:title><translate>Ledger</translate></template>
        </TitleBar>
        <div class="content">
            <b-nav tabs>
                <b-nav-item :to="Urls['accountants:ledger']()" :class="getTabClass('Ledger')"><translate>Cost categories</translate></b-nav-item>
                <b-nav-item :to="Urls['accountants:ledger_categories']()" :class="getTabClass('LedgerCategoriesTable')"><translate>Ledger categories</translate></b-nav-item>
            </b-nav>
            
            <p class="description-text">{{getDescription}}</p>
            <router-view></router-view>
        </div>
    </div>
  </template>
  <script>
  import TitleBar from "@/components/TitleBar"

  export default {
    name: "Ledger",
    components: {TitleBar},
    methods: {
        getTabClass(tabType) {
            if (tabType === this.$route.name)
                return "active-tab";
            return "disabled-tab";
        }
    },
    computed: {
        getDescription() {
            if (this.$route.name === "CostCategories")
                return this.$gettext('These cost types will be seen by all your customers and they will be able to book their receipts on these entries. If you want to hide cost types, archive them. If you want to manage cost types per customer, you have to go to your customers local account.');
            return this.$gettext('Ledgers are only used for internal use and not visible to your customers. You can use this to indicate the different types of receipts (e.g. "investments" vs "expenses") or group multiple cost types in one overarching ledger.');
        }
    }
  }
  </script>
  <style lang="scss" scoped>
  .content {
      padding-left: 15px;
      padding-right: 15px;
      padding-top: 20px;
  }
  .description-text {
      color: $colorTextSemi;
      padding-top: 20px;
      padding-bottom: 15px;
  }
  </style>
  <style lang="scss">
  .content {
      .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
          border-color: #ffffff00 !important;
      }
  }
  .active-tab {
      border-bottom: 2px solid $colorBrand;
      a {
          color: $colorTextSemi !important;
      }
  }
  .disabled-tab {
      a {
          color: $colorUnassigned !important;
      }
  }
  </style>